import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Pencil } from "lucide-react";
import { getCustomerById, CustomerDetail } from "../../api/customerApi";
import { showError } from "../../utils/ alert";

export default function CustomerDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState<CustomerDetail | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchCustomer = async () => {
    if (!id) return;

    try {
      setLoading(true);
      const { data } = await getCustomerById(Number(id));
      setCustomer(data.data);
    } catch (error) {
      showError("Failed", "Failed to load customer data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const formatDate = (value?: string) => {
    if (!value) return "-";
    const date = new Date(value);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <AdminLayout>
      <div className="bg-white rounded-3xl p-6">
        <div className="mb-4 text-sm text-gray-500">
          Customer &gt; Customer List &gt; Detail Customer
        </div>

        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold">Basic Information</h2>

          <button
            onClick={() => navigate(`/Customer?editId=${id}`)}
            className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
            <Pencil size={16} />
            Edit Customer
          </button>
        </div>

        {loading && <p>Loading...</p>}

        {!loading && !customer && <p>Customer not found.</p>}

        {!loading && customer && (
          <div className="grid grid-cols-2 gap-y-4 gap-x-8">
            <div>
              <span className="text-gray-500">Customer Name</span>
              <p className="font-medium">{customer.customer_name}</p>
            </div>
            <div>
              <span className="text-gray-500">Company Name</span>
              <p className="font-medium">{customer.company_name || "-"}</p>
            </div>

            <div>
              <span className="text-gray-500">No. Telp</span>
              <p className="font-medium">{customer.phone || "-"}</p>
            </div>
            <div>
              <span className="text-gray-500">Email</span>
              <p className="font-medium">{customer.email || "-"}</p>
            </div>

            <div>
              <span className="text-gray-500">NPWP</span>
              <p className="font-medium">{customer.npwp || "-"}</p>
            </div>
            <div>
              <span className="text-gray-500">Status</span>
              <p>
                <span
                  className={`rounded-full px-3 py-1 text-xs font-medium ${
                    customer.status === "Active"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}>
                  {customer.status}
                </span>
              </p>
            </div>

            <div className="col-span-2">
              <span className="text-gray-500">Address</span>
              <p className="font-medium">{customer.address || "-"}</p>
            </div>

            <div className="col-span-2 pt-2 border-t">
              <span className="text-gray-500">Create at</span>
              <p className="font-medium">{formatDate(customer.createdAt)}</p>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
